import React from "react";
import {
  HiOutlineClock,
  HiOutlineFire,
  HiOutlineUserGroup,
} from "react-icons/hi2";

export function PosterMetadata({ recipe }) {
  const r = recipe;
  if (!r) return null;

  return (
    <div className="flex flex-wrap gap-x-3 gap-y-1 text-white/90 text-[11px] flex-shrink-0">
      {r.prep_time != null && (
        <span className="flex items-center gap-0.5">
          <HiOutlineClock className="w-3 h-3 shrink-0" />
          {r.prep_time} min
        </span>
      )}
      {r.cook_time != null && (
        <span className="flex items-center gap-0.5">
          <HiOutlineFire className="w-3 h-3 shrink-0" />
          {r.cook_time} min
        </span>
      )}
      {r.servings != null && (
        <span className="flex items-center gap-0.5">
          <HiOutlineUserGroup className="w-3 h-3 shrink-0" />
          {r.servings}
        </span>
      )}
      {r.difficulty && <span>⭐ {r.difficulty}</span>}
    </div>
  );
}
